// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RadiusBottomleftOutlinedSvg from "@fishx/icons-svg/es/asn/RadiusBottomleftOutlined";
import FishxIcon from '../components/FishxIcon';

var RadiusBottomleftOutlined = function RadiusBottomleftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RadiusBottomleftOutlinedSvg
  }));
};

RadiusBottomleftOutlined.displayName = 'RadiusBottomleftOutlined';
export default React.forwardRef(RadiusBottomleftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RadiusBottomleftOutlined.js
// module id = 3964
// module chunks = 0